import { useRouter } from 'next/router';
import React from 'react';
import i18n from 'utils/i18n';
import { useForm } from 'react-hook-form';
import { UseSearchBoxProps } from 'react-instantsearch';

type FormData = {
  query: string;
};

const Search: React.FC<UseSearchBoxProps> = () => {
  const { locale, push } = useRouter();
  const { dictionary } = i18n[(locale as AcceptedLocales) || 'en-US'];
  const { register, handleSubmit } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    push({
      pathname: '/new-search',
      query: { query: data.query },
    });
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="relative">
          <input
            {...register('query')}
            className="shadow-none focus:shadow-none bg-textInputBackground h-8 placeholder-textRegular text-textRegular text-sm font-normal pl-8 pr-3 w-newSearch border-border border-2 focus:border-inputAccessability hover:border-inputAccessability"
            placeholder={dictionary.searchPlaceholder}
            autoComplete="off"
          />
          <svg
            className="h-4 w-auto absolute left-5 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
            // width="20"
            // height="18"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.2386 17.7918L12.616 13.0882C13.5171 11.8867 14.0178 10.4849 14.0178 8.88291C14.0178 4.97796 10.9138 1.87402 7.00889 1.87402C3.10394 1.87402 0 4.97796 0 8.88291C0 12.7879 3.10394 15.8918 7.00889 15.8918C8.61092 15.8918 10.0127 15.3912 11.2142 14.49L15.8368 19.1936L17.2386 17.7918ZM2.00254 8.88291C2.00254 6.07936 4.20534 3.87656 7.00889 3.87656C9.81245 3.87656 12.0152 6.07936 12.0152 8.88291C12.0152 11.6865 9.81245 13.8893 7.00889 13.8893C4.20534 13.8893 2.00254 11.6865 2.00254 8.88291Z"
              className="fill-textRegular"
            />
          </svg>
        </div>
      </form>
    </div>
  );
};

export default Search;
